import React from 'react';
export function AIHero() {
  return <section className="relative py-20 md:py-32 overflow-hidden" data-id="element-213">
      <div className="absolute inset-0 w-full h-full" data-id="element-214">
        <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-215">
          <source src="https://cdn.magicpatterns.com/uploads/v2gJPvvYeZUrE2eGgGTMSP/vid2.mp4" type="video/mp4" data-id="element-216" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-header/60 via-primary/50 to-primary/80" data-id="element-217"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-218">
        <div className="text-center" data-id="element-219">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 load-fade-in-up stagger-1" data-id="element-220">
            AI & Automation Solutions
          </h1>
          <p className="text-xl text-blue-200 leading-relaxed load-fade-in-up stagger-2" data-id="element-221">
            Magnus Software brings enterprise-grade AI capabilities to your
            business. From intelligent assistants to automated workflows, we
            implement practical AI solutions that reduce manual work, improve
            decision-making, and scale your operations.
          </p>
        </div>
      </div>
    </section>;
}